import { supabase } from '../../../lib/supabase';
import { AddLineInput, CartLine, CheckoutPaymentInput, UUID } from '../types';

export const cartService = {
	 async ensureCart(businessId: UUID, locationId: UUID, customerId?: UUID | null): Promise<{ cartId: UUID }> {
		 const { data, error } = await supabase.rpc('upsert_cart', {
			 p_business_id: businessId,
			 p_location_id: locationId,
			 p_customer_id: customerId ?? null
		 });
		 if (!error && data) return { cartId: (data as any).cart_id as UUID };
		 // Fallback: if RPC conflicts or fails, try to find existing draft cart
		 const { data: existing, error: selectErr } = await supabase
			 .from('carts')
			 .select('id')
			 .eq('business_id', businessId)
			 .eq('location_id', locationId)
			 .eq('status', 'draft')
			 .limit(1)
			 .maybeSingle();
		 if (existing?.id) return { cartId: existing.id as UUID };
		 if (error) throw error;
		 if (selectErr) throw selectErr;
		 throw new Error('Failed to ensure cart');
	 },

	 async addLine(cartId: UUID, input: AddLineInput): Promise<{ cartLineId: UUID; merged: boolean }> {
		 const { data, error } = await supabase.rpc('add_cart_line', {
			 p_cart_id: cartId,
			 p_item_id: input.itemId,
			 p_quantity: input.quantity,
			 p_attributes_json: input.attributes,
			 p_services_json: input.serviceIds,
			 p_modifiers_json: input.modifierIds,
			 p_pricing_snapshot_json: input.pricingSnapshot,
			 p_config_hash: input.configHash
		 });
		 if (error) throw error;
		 return { cartLineId: data.cart_line_id as UUID, merged: !!data.merged };
	 },

	 async checkout(cartId: UUID, payments: CheckoutPaymentInput[]): Promise<{ orderId: UUID }> {
		 const { data, error } = await supabase.rpc('checkout_cart', {
			 p_cart_id: cartId,
			 p_payments_json: payments
		 });
		 if (error) throw error;
		 return { orderId: data.order_id as UUID };
	 }
,
	async getCartLines(cartId: UUID): Promise<CartLine[]> {
		 const { data, error } = await supabase
			 .from('cart_lines')
			 .select('*')
			 .eq('cart_id', cartId)
			 .order('created_at');
		 if (error) throw error;
		 return (data as unknown as CartLine[]) || [];
	}
};


